import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, FileUpload, FormRow, TagsInput } from '../controls';

const defaultLinks = {
  instagram: '',
  twitter: '',
  facebook: '',
  web: '',
};

function buildDefaultValues(performer) {
  return {
    performerDescription: performer.performerDescription || '',
    performerName: performer.performerName || '',
    hometown: performer.hometown || '',
    type: performer.type || undefined,
    subtype: performer.subtype || undefined,
    links: performer.links || defaultLinks,
  };
}

export function PerformerForm({
  performer,
  handleSave,
  performerTypes,
  onFileUpload,
  onFileDelete,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(performer),
    mode: 'onSubmit',
  });

  const performerId = performer?.performerId;

  useEffect(() => {
    reset(buildDefaultValues(performer));
  }, [performerId, reset]);

  const types = performerTypes.types || [];
  const subtypes = performerTypes.subtypes || [];

  const fileList = [];

  if (performer.photoURL) {
    fileList.push({
      uid: '-1',
      name: performer.performerPhoto,
      url: performer.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <div className="flex">
        <div className="w-3/4 p-4">
          <FormRow label="Performer Name" error={errors.performerName?.message}>
            <input
              type="text"
              placeholder="Name"
              {...register('performerName', {
                required: 'Performer name is required',
              })}
            />
          </FormRow>
          <FormRow label="Hometown">
            <input
              type="text"
              placeholder="Hometown"
              {...register('hometown')}
            />
          </FormRow>
          <FormRow label="Type" error={errors.type?.message}>
            <Controller
              name="type"
              control={control}
              render={({ field }) => (
                <TagsInput
                  value={field.value}
                  placeholder="Select or enter a type"
                  options={types}
                  onChange={field.onChange}
                />
              )}
            />
          </FormRow>
          <FormRow label="Subtype">
            <Controller
              name="subtype"
              control={control}
              render={({ field }) => (
                <TagsInput
                  value={field.value}
                  placeholder="Select or enter a subtype"
                  options={subtypes}
                  onChange={field.onChange}
                />
              )}
            />
          </FormRow>
        </div>
        <div className="w-1/4 p-4">
          <FormRow>
            <div className="w-full">
              <FileUpload
                fileList={fileList}
                onFileUpload={onFileUpload}
                onFileDelete={onFileDelete}
              />
            </div>
          </FormRow>
        </div>
      </div>
      <FormRow label="Notes">
        <textarea
          placeholder="Performer Biography..."
          {...register('performerDescription')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
        <input type="text" placeholder="Website" {...register('links.web')} />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
        <input
          type="text"
          placeholder="Facebook"
          {...register('links.facebook')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
        <input
          type="text"
          placeholder="Twitter"
          {...register('links.twitter')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
        <input
          type="text"
          placeholder="Instagram"
          {...register('links.instagram')}
        />
      </FormRow>
      <Button className="float-right mt-4" mode="dark" type="submit">
        Save Performer
      </Button>
    </form>
  );
}
